const deleteQueryParameterAfterUsed = (url, parameters) => {
  parameters.forEach(parameter => {
    url.searchParams.delete(parameter);
  });
  window.history.replaceState({}, '', url);
}

export default deleteQueryParameterAfterUsed;
